import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { ThamService } from './tham.service';

@Pipe({
  name: 'thamUseProxyCdn',
  pure: true,
})
export class ThamUseProxyCdnPipe implements PipeTransform {
  readonly #tham = inject(ThamService);

  transform(content: string | null | undefined): Observable<string> {
    return this.#tham.replaceThamDomainWithProxyCdn$(content);
  }
}
